// =============================================================================
// Sample Documents for Transform Studio
// =============================================================================

export const SAMPLE_DOCUMENT = `{
  "_id": "60002e5e19e23b5c08a6c03c",
  "first_name": "John",
  "last_name": "Smith",
  "full_name": "John Smith",
  "email": "john.smith@acme.com",
  "phone": "+1-555-123-4567",
  "ssn": "123-45-6789",
  "date_of_birth": "1985-03-15T00:00:00Z",
  "created_at": "2024-01-15T10:30:00Z",
  "active": true,
  "postcode": "10001",
  "internal_notes": "VIP customer - handle with care",
  "password_hash": "a1b2c3d4e5f6...",
  "address": {
    "street": "123 Main St",
    "city": "New York",
    "contact_email": "billing@acme.com",
    "contact_phone": "+1-555-987-6543"
  },
  "dependents": [
    {
      "name": "Jane Smith",
      "date_of_birth": "2010-07-22T00:00:00Z",
      "ssn": "987-65-4321"
    }
  ]
}`;

export const SAMPLE_BATCH_DOCUMENT = `[
  {
    "_id": "60002e5e19e23b5c08a6c001",
    "email": "alice@example.com",
    "phone": "+1-555-111-1111",
    "name": "Alice Johnson",
    "status": "active"
  },
  {
    "_id": "60002e5e19e23b5c08a6c002",
    "email": "bob@example.com",
    "phone": "+1-555-222-2222",
    "name": "Bob Williams",
    "status": "pending"
  },
  {
    "_id": "60002e5e19e23b5c08a6c003",
    "email": "carol@example.com",
    "phone": "+1-555-333-3333",
    "name": "Carol Davis",
    "status": "active"
  }
]`;
